import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React from 'react';
import { useIntl } from 'react-intl-next';
import FeatureGates from '@atlaskit/feature-gate-js-client';
import { NotificationListLayout } from '@atlassian/notification-common';
import { LoadingState } from '@atlassian/notification-common/types';
import { useGroupReadStateActions, useIsGroupsMarkAllAsReadVisible, useNotificationCategoryFilters, useNotificationGroups, useNotificationGroupsController, useNotificationListFilterActions, useNotificationReadActions, useNotificationsLoadingState, useNotificationStateFilters } from '@atlassian/notification-store';
import NotificationList from './notification-list';
var ConnectedNotificationGroupList = function ConnectedNotificationGroupList(_ref) {
  var product = _ref.product,
    ThirdPartyNotificationNudge = _ref.ThirdPartyNotificationNudge,
    emojiProvider = _ref.emojiProvider,
    mentionProvider = _ref.mentionProvider,
    onCommentCreatedFn = _ref.onCommentCreatedFn,
    isEligibleForBellNotifRepliesCtxExp = _ref.isEligibleForBellNotifRepliesCtxExp;
  var _useNotificationGroup = useNotificationGroups(),
    _useNotificationGroup2 = _slicedToArray(_useNotificationGroup, 1),
    groups = _useNotificationGroup2[0];
  var _useGroupReadStateAct = useGroupReadStateActions(),
    handleMarkAllGroupsAsRead = _useGroupReadStateAct.handleMarkAllGroupsAsRead;
  var _useNotificationReadA = useNotificationReadActions(),
    handleMarkAllV2NotificationsRead = _useNotificationReadA.handleMarkAllV2NotificationsRead;
  var _useIntl = useIntl(),
    locale = _useIntl.locale;
  var _useNotificationGroup3 = useNotificationGroupsController(locale, false),
    fetchData = _useNotificationGroup3.fetchData;
  var _useNotificationState = useNotificationStateFilters(),
    _useNotificationState2 = _slicedToArray(_useNotificationState, 1),
    filters = _useNotificationState2[0];
  var isMarkAllAsReadVisible = useIsGroupsMarkAllAsReadVisible();
  var notificationFilters = useNotificationListFilterActions();
  var _useNotificationsLoad = useNotificationsLoadingState(filters),
    _useNotificationsLoad2 = _slicedToArray(_useNotificationsLoad, 1),
    notificationState = _useNotificationsLoad2[0];
  var _useNotificationCateg = useNotificationCategoryFilters(),
    _useNotificationCateg2 = _slicedToArray(_useNotificationCateg, 1),
    categoryFilters = _useNotificationCateg2[0];
  var isMarkAllTimestampEnabled = FeatureGates.checkGate('post-office_enable_new-mark-all-endpoint');
  return /*#__PURE__*/React.createElement(NotificationListLayout, {
    fetchData: fetchData,
    listSize: groups.length,
    fetchState: notificationState.fetchState,
    canLoadMore: notificationState.fetchState === LoadingState.COMPLETE && !!notificationState.continuationToken,
    notificationTabs: categoryFilters,
    notificationFilters: notificationFilters,
    NotificationListComponent: NotificationList,
    isMarkAllAsReadVisible: isMarkAllAsReadVisible,
    handleMarkAllNotificationsRead: isMarkAllTimestampEnabled ? handleMarkAllV2NotificationsRead : handleMarkAllGroupsAsRead,
    product: product,
    ThirdPartyNotificationNudge: ThirdPartyNotificationNudge,
    emojiProvider: emojiProvider,
    mentionProvider: mentionProvider,
    onCommentCreatedFn: onCommentCreatedFn,
    isEligibleForBellNotifRepliesCtxExp: isEligibleForBellNotifRepliesCtxExp
  });
};
export default ConnectedNotificationGroupList;